module.exports = __webpack_public_path__ + "static/footer-9f5deec614719f0a0cf1171447f67d77.png";